import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { UntilDestroy } from '@ngneat/until-destroy';
import { I18NextPipe } from 'angular-i18next';
import { SummaryComputersFacade } from 'mbs-ui-shared@facades/summary-computers.facade';
import moment from 'moment';
import { map } from 'rxjs/operators';
import { DateTimeFormatComponent } from './date-time-format.component';

@UntilDestroy()
@Component({
  selector: 'mbs-rmm-date-time-format',
  templateUrl: './date-time-format.component.html',
  imports: [CommonModule, I18NextPipe, NgbTooltipModule]
})
export class RmmDateTimeFormatComponent extends DateTimeFormatComponent {
  private summaryFacade = inject(SummaryComputersFacade);

  getAgentUtcOffsetValue() {
    if (!this.isNullTimezone()) return super.getAgentUtcOffsetValue();

    const signal = this.hid() ? this.summaryFacade.systemTimeByHid$(this.hid()) : this.summaryFacade.currentSystemTime$;

    return signal.pipe(
      map((data) => {
        if (data?.value) {
          const regexp = /UTC(.*)\)/;
          const utcOffsetValue = regexp.exec(data.value)[1];
          return utcOffsetValue ? moment().utcOffset(utcOffsetValue).utcOffset() : null;
        } else {
          return null;
        }
      })
    );
  }
}
